import PropTypes from "prop-types"
import React from "react"
import { branchRecordType } from "../../../../shared-prop-types"

import CareProviderCard from "../CareProviderCard/CareProviderCard"

const ProviderList = ({
  branchRecords,
  clickEventBaseProperties,
  currentUrl,
  showCareTypeLabel,
  showTownLabel,
  locationName,
}) =>
  branchRecords.map((branchRecord, i) => (
    <CareProviderCard
      key={`provider-list-branch-record-${branchRecord.id}`}
      branchRecord={branchRecord}
      clickEventBaseProperties={clickEventBaseProperties}
      index={i}
      currentUrl={currentUrl}
      showCareTypeLabel={showCareTypeLabel}
      showTownLabel={showTownLabel}
      locationName={locationName}
    />
  ))

ProviderList.propTypes = {
  branchRecords: PropTypes.arrayOf(branchRecordType),
  currentUrl: PropTypes.string,
  clickEventBaseProperties: PropTypes.shape({
    name: PropTypes.string,
    properties: PropTypes.object,
  }),
  showCareTypeLabel: PropTypes.bool,
  showTownLabel: PropTypes.bool,
  locationName: PropTypes.string,
}
ProviderList.defaultProps = {
  branchRecords: [],
  currentUrl: undefined,
  clickEventBaseProperties: undefined,
  showCareTypeLabel: false,
  showTownLabel: false,
}

export default ProviderList
